import React from 'react'

import '../Styles/NewPromoSellOutStyles.css'

const NewPromoSellOutTag = ({ product, isBigTag }) => {
    const bigTagStyle = isBigTag ? 'promo-header-big' : ''
    const tags = [];

    if (product.isSellOut) {
        tags.push(<span className={`promo-header ${bigTagStyle} ms-3`}>Wyprzedaż</span>);
    }
    if (product.isPromo) {
        tags.push(<span className={`promo-header ${bigTagStyle} ms-3`}>Promocja</span>);
    }
    if (product.isNew) {
        tags.push(<span className={`promo-header ${bigTagStyle} ms-3`}>Nowość</span>);
    }

    return tags.length > 0 ? tags : null;

}

export default NewPromoSellOutTag